import { useEffect, useState, useCallback } from "react"
import { useDispatch } from "react-redux"
import { Layout, TextInput, SelectBox, PrimaryButton, ImageArea } from "../components"
import { db } from "../firebase"
import { push } from 'connected-react-router'
import styled from 'styled-components'
import { saveProduct } from '../reducks/products/operations'
// mui
import Switch from '@material-ui/core/Switch'
import AddBoxIcon from '@material-ui/icons/AddBox'
import DeleteIcon from '@material-ui/icons/Delete'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'

const ProductEdit = () => {
    const dispatch = useDispatch()

    let id = window.location.pathname.split('/product/edit')[1];

    if (id) {
        id = id.split('/')[1]
    }

    const [images, setImages] = useState('')
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [brand, setBrand] = useState('')
    const [brands, setBrands] = useState([])
    const [category, setCategory] = useState('')
    const [categories, setCategories] = useState([])
    const [price, setPrice] = useState('')
    const [discount, setDiscount] = useState('')
    const [variations, setVariations] = useState([{ 
        order: "", variationName: "", quantity: "" 
    }])
    const [metaTitle, setMetaTitle] = useState('')
    const [metaDescription, setMetaDescription] = useState('')
    const [metaKeywords, setMetaKeywords] = useState('')
    const [isDraft, setIsDraft] = useState(false)
    const [isTrash, setIsTrash] = useState(false)

    // ゴミ箱移動処理
    const moveToTrash = useCallback(()=>{
        return db.collection('products').doc(id).set({isTrash: true}, {merge: true})
                      .then(() => {dispatch(push('/admin/product'))})
                      .catch( error => {throw new Error(error)})
    },[id, dispatch])
    const moveFromTrash = useCallback(()=>{
        return db.collection('products').doc(id).set({isTrash: false}, {merge: true})
                      .then(() => {dispatch(push('/admin/product'))})
                      .catch( error => {throw new Error(error)})
    },[id, dispatch])

    const handleInputChange = (e, index) => {
        const { name, value } = e.target
        const list = [...variations]
        list[index][name] = value
        setVariations(list);
    }
    const handleAddClick = index => {
        setVariations([...variations, { 
            order: index+2,
            variationName: "", 
            quantity: "" 
        }]);
    }
    const handleRemoveClick = index => {
        // 確認
        const list = [...variations]
        const conf = window.confirm('一度削除すると元に戻せません。削除してよろしいですか？')
        if (conf) {
            // 既存のものであればFirestoreから削除
            if (list[index].id) {
                db.collection('products').doc(id)
                  .collection('variations').doc(list[index].id)
                  .delete()
            }
            // Stateから削除
            list.splice(index, 1);
            setVariations(list);
        } else {
            return;
        }
    };
    const handleSectionUp = index => {
        const list = [...variations]
        list[index].order = list[index].order - 1
        list[index-1].order = list[index].order + 1
        list.sort((a,b) => {
            if(a.order < b.order) return -1
            if(a.order > b.order) return 1
            return 0
        })
        setVariations(list);
    }
    const handleSectionDown = index => {
        const list = [...variations]
        list[index].order = list[index].order + 1
        list[index+1].order = list[index].order - 1
        list.sort((a,b) => {
            if(a.order < b.order) return -1
            if(a.order > b.order) return 1
            return 0
        })
        setVariations(list);
    }

    // ブランド一覧を取得
    useEffect( () => {
        db.collection('brands')
          .orderBy('order','asc')
          .get()
          .then( snapshots => {
              const list = []
              snapshots.forEach(snapshot => {
                  const data = snapshot.data()
                  list.push({
                      id: data.id,
                      name: data.name
                  })
              })
              setBrands(list)
          })
        return false
    }, []);

    // カテゴリ一覧を取得
    useEffect( () => {
        if (brand) {
            db.collection('brands').doc(brand)
              .collection('categories')
              .orderBy('order','asc')
              .get()
              .then( snapshots => {
                  const list = []
                  snapshots.forEach(snapshot => {
                      const data = snapshot.data()
                      list.push({
                          id: data.id,
                          name: data.name
                      })
                  })
                  setCategories(list)
              })
        }
        return false
    }, [brand]);

    useEffect( () => {
        if (id) {
            db.collection('products').doc(id).get()
              .then(snapshot => {
                    const data = snapshot.data()
                    setImages(data.images)
                    setName(data.name)
                    setDescription(data.description)
                    setBrand(data.brand)
                    setCategory(data.category)
                    setPrice(data.price)
                    setDiscount(data.discount)
                    setMetaTitle(data.metaTitle)
                    setMetaDescription(data.metaDescription)
                    setMetaKeywords(data.metaKeywords)
                    setIsDraft(data.isDraft)
                    setIsTrash(data.isTrash)
              })
              .then(()=>{
                    db.collection('products').doc(id).collection('variations').orderBy('order','asc').get()
                      .then(snapshots=>{
                            const variationTempList = []
                            snapshots.forEach(snapshot => {
                                const variation = snapshot.data()
                                variationTempList.push(variation)
                            })
                            setVariations(variationTempList)
                      })
              })
        }
        return false
    }, [id]);
    
    
    return (
        <Layout>
            <div className='spacer-50'></div>
            <h2>商品の登録・編集</h2>
            <div className='spacer-50'></div>

            <InputWrapper>
                <ImageArea images={images} setImages={setImages} />
                <TextInput 
                    fullWidth={true} label={'商品名'} multiline={false} required={true}
                    onChange={e=>setName(e.target.value)} rows={1} value={name} type={'text'}
                />
                <TextInput 
                    fullWidth={true} label={'商品の説明'} multiline={true} required={true}
                    onChange={e=>setDescription(e.target.value)} rows={5} value={description} type={'text'}
                />

                <div className='spacer-50' />

                <SelectBox 
                    label={'ブランド'}　required={true} select={setBrand} value={brand} options={brands}
                />
                <SelectBox 
                    label={'カテゴリー'}　required={false} select={setCategory} value={category} options={categories} 
                />

                <div className='spacer-50' />

                <TextInput 
                    fullWidth={true} label={'価格'} multiline={true} required={true}
                    onChange={e=>setPrice(e.target.value)} rows={1} value={price} type={'number'}
                />
                <TextInput 
                    fullWidth={true} label={'割引率'} multiline={true} required={true}
                    onChange={e=>setDiscount(e.target.value)} rows={1} value={discount} type={'number'}
                />
                <div className='spacer-50' />


                {variations.map((x, i) => {
                    return (
                        <Variations key={i}>
                            <Flexbox>
                                {variations.length !== 1 && (
                                <VariationName
                                    fullWidth={true} label={'バリエーション名'} multiline={true} required={true} rows={1} type={'text'}
                                    name="variationName"
                                    value={x.variationName} onChange={e => handleInputChange(e, i)}
                                />
                                )}
                                <VariationQuantity 
                                    fullWidth={true} label={'在庫数'} multiline={true} required={true} rows={1} type={'number'}
                                    name="quantity"
                                    value={x.quantity} onChange={e => handleInputChange(e, i)}
                                />
                                {variations.length !== 1 && (
                                    <>
                                        { i !== 0 ? (
                                            <IconButton onClick={()=>handleSectionUp(i)}>
                                                <ArrowUpwardIcon/>
                                            </IconButton>
                                        ):(
                                            <IconButton disabled={true}>
                                                <ArrowUpwardIcon color="disabled" />
                                            </IconButton>
                                        )}
                                        { i !== variations.length - 1 ? (
                                            <IconButton onClick={()=>handleSectionDown(i)}>
                                                <ArrowDownwardIcon />
                                            </IconButton>
                                        ):(
                                            <IconButton disabled={true}>
                                                <ArrowDownwardIcon color="disabled" />
                                            </IconButton>
                                        )}
                                        <IconButton onClick={()=>handleRemoveClick(i)}>
                                            <DeleteIcon/>
                                        </IconButton>
                                    </>
                                )}
                                {variations.length - 1 === i && (
                                    <AddButton onClick={()=>handleAddClick(i)}>
                                        <AddBoxIcon color={"primary"} fontSize={'large'} />
                                    </AddButton>
                                )}
                            </Flexbox>
                        </Variations>
                    )
                })}
                
                <div className='spacer-50' />

                <TextInput 
                    fullWidth={true} label={'titleメタデータ'} multiline={false} rows={1} type={'text'} 
                    value={metaTitle} onChange={e=>setMetaTitle(e.target.value)}
                />
                <TextInput 
                    fullWidth={true} label={'descriptionメタデータ'} multiline={true} rows={2} type={'text'} 
                    value={metaDescription} onChange={e=>setMetaDescription(e.target.value)}
                />
                <TextInput 
                    fullWidth={true} label={'keywordsメタデータ'} multiline={false} rows={1} type={'text'} 
                    value={metaKeywords} onChange={e=>setMetaKeywords(e.target.value)}
                />

                <div className='spacer-100' />
                <div style={{textAlign: 'center'}}>
                    <SwitchWrapper>
                        <div>下書きとして保存</div>
                        <Switch
                            color="primary" checked={isDraft}
                            onChange={()=>setIsDraft(!isDraft)}
                        />
                    </SwitchWrapper>
                    <div className='spacer-25' />
                    <PrimaryButton 
                        label={isDraft ? '下書きを保存する' : '公開する'} 
                        operation={()=> dispatch(saveProduct(id,images,name,description,brand,category,price,discount,variations, metaTitle, metaDescription, metaKeywords, isDraft, isTrash))}
                    />
                    <div className='spacer-25' />
                    {isTrash ? (
                        <button onClick={moveFromTrash}>ゴミ箱から戻す</button>
                    ) : (
                        <button onClick={moveToTrash}>ゴミ箱に入れる</button>
                    )}
                    <div className='spacer-25' />
                    <button onClick={()=> dispatch(push('/admin/product'))}>キャンセル</button>
                </div>
                <div className='spacer-50'></div>
            </InputWrapper  >
            <div className='spacer-50' />
        </Layout>
        
    )
}
export default ProductEdit

const InputWrapper = styled.div`
    max-width: 480px;
    margin: 0 auto;
`
const AddButton = styled(IconButton)`
    position: absolute !important;
    left: 50%;
    transform: translateX(-50%);
    bottom: -75px;
`
const Variations = styled.section`
    position: relative !important;
    margin-bottom: 10px;
    padding: 5px;
`
const Flexbox = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`
const VariationName = styled(TextField)`
    flex: 1 !important;
    padding-right: 10px !important;
`
const VariationQuantity = styled(TextField)`
    width: 75px !important;
`
const SwitchWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`